import { render, staticRenderFns } from "./BrandPicker.vue?vue&type=template&id=147318eb&scoped=true&"
import script from "./BrandPicker.vue?vue&type=script&lang=ts&"
export * from "./BrandPicker.vue?vue&type=script&lang=ts&"
import style0 from "./BrandPicker.vue?vue&type=style&index=0&id=147318eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147318eb",
  null
  
)

export default component.exports